import { motion } from "framer-motion";

export const Media = ({ poster, alt, style, testid, kenburns = false, className = "" }) => (
  <motion.div style={style} className={`absolute inset-0 ${className}`} data-testid={testid}>
    <img
      src={poster}
      alt={alt}
      className={`absolute inset-0 w-full h-full object-cover ${kenburns ? "animate-kenburns" : ""}`}
    />
  </motion.div>
);
